'use strict';

import React from 'react';
import { Link } from 'react-router';
import UserIncome from './UserIncomeComponent';
import UserExplore from './UserExploreComponent';
import UserAlbums from './UserAlbumsComponent';
import UserRelation from './UserRelationComponent';
import UserStore from 'stores/UserStore';
import API from 'sources/API';
import UserActions from 'actions/UserActions';

import 'styles/User.scss';

class UserComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = UserStore.getState();
    this.state.moreIntro = false;
    this.state.userIntroModalOpen = false;
    this.state.currentTab = 'explore';
    this.onChange = this.onChange.bind(this);
    this.toggleUserIntroModal = this.toggleUserIntroModal.bind(this);
  }
  componentDidMount() {
    if(API.isWechat){
      fetch(API.getWechatConfig).then(res=>res.json()).then(json=>{
        if(json.appId) {
            window.wx.config(json);
        }
      })
    }
    window.scrollTo(0, 0);
    UserStore.listen(this.onChange);
    UserActions.fetchUser(this.props.params.id);
    UserActions.fetchAgent(this.props.params.id)

    // Baidu tongji
    window._hmt.push(['_trackPageview', this.props.location.pathname]);
  }
  componentWillUnmount() {
    UserStore.unlisten(this.onChange);
  }
  onChange(state) {
    if(!state.user_id && this.state.user_id){
      state.user_id = this.state.user_id
    }
    this.setState(state);
  }
  onTabChange(tab) {
    this.setState({currentTab: tab});
  }
  componentWillReceiveProps(nextProps) {
    if(this.props.params.id !== nextProps.params.id) {
      if(nextProps.params.id) {
        UserActions.fetchUser(nextProps.params.id);
      }
    }
  }
  onFollowClick(type) {
    UserActions.postFollow(type);
  }
  componentDidUpdate() {
    let intro = document.querySelector('p.user-intro.fz12');
    if(intro.clientHeight > 34) {
      if(!this.state.moreIntro) {
        this.setState({moreIntro: true});
      }
    } else {
      if(this.state.moreIntro) {
        this.setState({moreIntro: false});
      }
    }
  }
  toggleUserIntroModal(event) {
    if(this.state.userIntroModalOpen) {
      this.setState({userIntroModalOpen: false});
    } else {
      this.setState({userIntroModalOpen: true});
    }
  }
  render() {
    let optBtn, tab, userIntroModal;
    if(this.state.user) {
      if(this.state.user.relation === 1) {
        optBtn = (
          <button className="btn-follow button button-default" onClick={this.onFollowClick.bind(this, 'follow')}>关注</button>
        );
      } else if(this.state.user.relation === 3) {
        optBtn = (
          <button className="btn-follow button" onClick={this.onFollowClick.bind(this, 'unfollow')}>取消关注</button>
        );
      } else if(this.state.user.relation === 4) {
        optBtn = (
          <button className="btn-follow button" onClick={this.onFollowClick.bind(this, 'unfollow')}>互相关注</button>
        );
      }
    }
    switch(this.state.currentTab) {
      case 'income':
        tab = <UserIncome id={this.props.params.id} active={this.state.currentTab==='income'?true:false} />
        break;
      case 'explore':
        tab = <UserExplore id={this.props.params.id} active={this.state.currentTab==='explore'?true:false} />
        break;
      case 'albums':
        tab = <UserAlbums id={this.props.params.id} active={this.state.currentTab==='albums'?true:false} />
        break;
      case 'relation':
        tab = <UserRelation id={this.props.params.id} active={this.state.currentTab==='relation'?true:false} />
        break;
      case 'business':
        tab = (
          <div className="business">
            <Link to={`/businesses/${this.props.params.id}`} href="javascript:void(0);" className="block width-all">
              她的店铺
            </Link>
            <Link to={`/agent/${this.props.params.id}`} href="javascript:void(0);" className="block width-all">
              她是代理
            </Link>
          </div>
        )
        break;
    }
    if(this.state.userIntroModalOpen) {
      userIntroModal = (
        <div className="reveal-overlay">
          <div className="reveal" data-reveal>
            <button className="close-button" data-close aria-label="Close modal" type="button" onClick={this.toggleUserIntroModal}>
              <span aria-hidden="true">&times;</span>
            </button>
            <p className="fz-14 text-gray">{this.state.user.summary}</p>
          </div>
        </div>
      );
    }
    let gender,avatar;
    if(this.state.user && this.state.user.gender === 0) {
      gender = <i className="ml-10 fz-12 fa fa-mars" aria-hidden="true"></i>
    } else if (this.state.user && this.state.user.gender === 1) {
      gender = <i className="ml-10 fz-12 fa fa-venus" aria-hidden="true"></i>
    }
    if(this.state.user){
      avatar = <img className="user-info-avatar contain" src={this.state.user.avatar} />
    }
    return (
      <div className="user-component">
        {userIntroModal}
        <div className='row user-info'>
          {avatar}
          <div className="user-info-meta">
            <h4>
              {this.state.user ? this.state.user.name : ''}
              {gender}
              {optBtn}
            </h4>
            <p className="fz12">
              <span className="text-gray">博客: </span>
              <a className="mr15" target="_blank" href={this.state.user ? `http://${this.state.user.website}` : ''}>{this.state.user ? this.state.user.website : ''}</a>
              <span className="text-gray">位置: </span>
              <a href="" className="text-black">{this.state.user ? this.state.user.location : ''}</a>
            </p>
          </div>
          <p className={this.state.moreIntro ? 'user-intro fz12 text-gray moreIntro' : 'user-intro fz12 text-gray'} onClick={this.state.moreIntro ? this.toggleUserIntroModal : null}>{this.state.user && this.state.user.summary ? this.state.user.summary : <i>这里空空如也～</i>}</p>
        </div>
        <div className="tab-nav row expanded text-center">
          <div className="small-2 columns menu-item">
            <a href="javascript:void(0);" onClick={this.onTabChange.bind(this, 'explore')} className={this.state.currentTab==='explore'?'active':''}>探索</a>
          </div>
          <div className="small-2 columns menu-item">
            <a href="javascript:void(0);" onClick={this.onTabChange.bind(this, 'albums')} className={this.state.currentTab==='albums'?'active':''}>专辑</a>
          </div>
          <div className="small-2 columns menu-item">
            <a href="javascript:void(0);" onClick={this.onTabChange.bind(this, 'relation')} className={this.state.currentTab==='relation'?'active':''}>关系</a>
          </div>
          <div className="small-2 columns menu-item">
            <a href="javascript:void(0);" onClick={this.onTabChange.bind(this, 'income')} className={this.state.currentTab==='income'?'active':''}>足迹</a>
          </div>
          <div className="small-2 columns menu-item">
            <a href="javascript:void(0);" onClick={this.onTabChange.bind(this, 'business')} className={this.state.currentTab==='business'?'active':''}>店铺</a>
          </div>
        </div>
        <div className="tabs-content">
          {tab}
        </div>
      </div>
    );
  }
}

UserComponent.displayName = 'UserComponent';
export default UserComponent;



// WEBPACK FOOTER //
// ./src/components/UserComponent.js